import { render } from "./Contents.vue?vue&type=template&id=a771e864&scoped=true"
import script from "./Contents.vue?vue&type=script&lang=js"
export * from "./Contents.vue?vue&type=script&lang=js"

import "./Contents.vue?vue&type=style&index=0&id=a771e864&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a771e864"]])

export default __exports__